import React from 'react'
import { useState } from 'react';

const OpcionesIconoTexto = (props) => {

    const { type, id, handleEstilosComponente, styles } = props;
    const [color, setColor] = useState(styles?.colorIcono)
    const [colorTitulo, setColorTitulo] = useState(styles?.colorTitulo)
    const [colorSubTitulo, setColorSubTitulo] = useState(styles?.colorSubTitulo)

    return (
        <>
            <div className='mb-2'>
                <h6>Titulo</h6>
                <input
                    type="text"
                    className="form-control form-control-sm"
                    defaultValue={styles?.titulo}
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'titulo' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Tamaño Titulo</h6>
                <input
                    type="number"
                    className="form-control form-control-sm"
                    defaultValue={styles?.tituloTamano}
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'tituloTamano' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Color Titulo</h6>
                <input
                    type="color"
                    id="exampleColorInput"
                    value={colorTitulo}
                    onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'colorTitulo' }); setColorTitulo(e.target.value) }}
                    title="Choose your color"
                />
            </div>
            <hr />
            <div className='mb-2'>
                <h6>Subtitulo</h6>
                <input
                    defaultValue={styles?.subTitulo}
                    type="text"
                    className="form-control form-control-sm"
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'subTitulo' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Tamaño Subtitulo</h6>
                <input
                    type="number"
                    className="form-control form-control-sm"
                    defaultValue={styles?.subTituloTamano}
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'subTituloTamano' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Color Subtitulo</h6>
                <input
                    type="color"
                    id="exampleColorInput"
                    value={colorSubTitulo}
                    onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'colorSubTitulo' }); setColorSubTitulo(e.target.value) }}
                    title="Choose your color"
                />
            </div>
            <hr />
            <div className='mb-2'>
                <h6>Icono</h6>
                <p>Puedes encontrar los iconos <a target="_blank" href='https://fontawesome.com/icons/'>aca</a></p>
                <p>Para insertar el icono le das copiar al texto donde dice HTML <b>{`<i class="fa-solid fa-check"></i>`}</b>  y eliminas el resto de texto para dejarlo de1 esta manera <b>fa-solid fa-check</b> </p>
                <input
                    defaultValue={styles?.nombre}
                    type="text"
                    className="form-control form-control-sm"
                    placeholder='fa-solid fa-check'
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'nombre' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Tamaño Icono</h6>
                <input
                    type="number"
                    className="form-control form-control-sm"
                    defaultValue={styles?.nombreTamanoIcon}
                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'nombreTamanoIcon' })}
                />
            </div>
            <div className='mb-2'>
                <h6>Color Icono</h6>
                <input
                    type="color"
                    id="exampleColorInput"
                    value={color}
                    onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'colorIcono' }); setColor(e.target.value) }}
                    title="Choose your color"
                />
            </div>
        </>
    )
}

export default OpcionesIconoTexto